import wootConstants from 'dashboard/constants/globals';

export const KANBAN_STAGE_KEYS = {
  BACKLOG: 'backlog',
  IN_PROGRESS: 'in_progress',
  TESTS: 'tests',
  DONE: 'done',
};

export const KANBAN_STAGES = [
  {
    id: KANBAN_STAGE_KEYS.BACKLOG,
    titleKey: 'KANBAN.STAGES.BACKLOG',
    descriptionKey: 'KANBAN.STAGES.BACKLOG_DESCRIPTION',
    accentClass: 'bg-[#F59E0B]',
  },
  {
    id: KANBAN_STAGE_KEYS.IN_PROGRESS,
    titleKey: 'KANBAN.STAGES.IN_PROGRESS',
    descriptionKey: 'KANBAN.STAGES.IN_PROGRESS_DESCRIPTION',
    accentClass: 'bg-[#2563EB]',
  },
  {
    id: KANBAN_STAGE_KEYS.TESTS,
    titleKey: 'KANBAN.STAGES.TESTS',
    descriptionKey: 'KANBAN.STAGES.TESTS_DESCRIPTION',
    accentClass: 'bg-[#7C3AED]',
  },
  {
    id: KANBAN_STAGE_KEYS.DONE,
    titleKey: 'KANBAN.STAGES.DONE',
    descriptionKey: 'KANBAN.STAGES.DONE_DESCRIPTION',
    accentClass: 'bg-[#059669]',
  },
];

export const STATUS_FILTER_OPTIONS = [
  {
    id: 'all',
    titleKey: 'KANBAN.FILTERS.ALL_STATUSES',
  },
  {
    id: wootConstants.STATUS_TYPE.OPEN,
    titleKey: 'KANBAN.FILTERS.STATUS_OPEN',
  },
  {
    id: wootConstants.STATUS_TYPE.PENDING,
    titleKey: 'KANBAN.FILTERS.STATUS_PENDING',
  },
  {
    id: wootConstants.STATUS_TYPE.RESOLVED,
    titleKey: 'KANBAN.FILTERS.STATUS_RESOLVED',
  },
];

export const getConversationKanbanStage = conversation => {
  const stage = conversation.custom_attributes?.kanban_stage;

  if (Object.values(KANBAN_STAGE_KEYS).includes(stage)) {
    return stage;
  }

  if (conversation.status === wootConstants.STATUS_TYPE.RESOLVED) {
    return KANBAN_STAGE_KEYS.DONE;
  }

  if (conversation.meta?.assignee?.id) {
    return KANBAN_STAGE_KEYS.IN_PROGRESS;
  }

  return KANBAN_STAGE_KEYS.BACKLOG;
};
